import { FinanceCircular } from '../types/catalog';

// Circular comercial oficial PSA Finance Argentina (Stellantis) Nro. 457.26 — Promociones 0 km Citroën, octubre 2026.
// Cuotas calculadas con el coeficiente "Cuota x $1.000 con IVA". No incluye seguro automotor.
export const citroenCircular: FinanceCircular = {
  brandId: 'citroen',
  lender: 'PSA Finance Argentina',
  reference: 'Circular comercial Nro. 457.26 · Octubre 2026',
  validFrom: '2026-10-01',
  validUntil: '2026-10-31',
  managementFeePct: 18,
  notes: ['La cuota no incluye seguro automotor.', 'Sujeto a aprobación crediticia de PSA Finance Argentina.'],
  lines: [
    {
      id: 'citroen-tasa-express-18',
      name: 'Tasa Express',
      detail: 'Toda la gama',
      maxAmount: 18000000,
      models: 'all',
      rateType: 'fija',
      audience: 'general',
      channel: 'TRAD',
      terms: [
        { term: 12, tna: 0, dealerContributionPct: 8, installmentPer1000: 83.33 },
        { term: 18, tna: 0, dealerContributionPct: 11, installmentPer1000: 55.56 },
        { term: 24, tna: 9.9, dealerContributionPct: 11, installmentPer1000: 47.83 },
        { term: 36, tna: 19.9, dealerContributionPct: 11, installmentPer1000: 40.6 },
        { term: 48, tna: 24.9, dealerContributionPct: 11, installmentPer1000: 37.46 },
      ],
    },
    {
      id: 'citroen-gama-26',
      name: 'Tasa fija Citroën',
      detail: 'Toda la gama',
      maxAmount: 26000000,
      models: 'all',
      rateType: 'fija',
      audience: 'general',
      channel: 'TRAD',
      terms: [
        { term: 12, tna: 4.9, dealerContributionPct: 10, installmentPer1000: 86.42 },
        { term: 18, tna: 14.9, dealerContributionPct: 10, installmentPer1000: 64.95 },
        { term: 24, tna: 22.9, dealerContributionPct: 10, installmentPer1000: 56.33 },
        { term: 36, tna: 26.9, dealerContributionPct: 10, installmentPer1000: 45.48 },
        { term: 48, tna: 29.9, dealerContributionPct: 10, installmentPer1000: 41.18 },
        { term: 60, tna: 29.9, dealerContributionPct: 10, installmentPer1000: 37.52 },
      ],
    },
    {
      id: 'citroen-prendario-uva-26',
      name: 'Prendario UVA',
      detail: 'Toda la gama',
      maxAmount: 26000000,
      models: 'all',
      rateType: 'uva',
      audience: 'general',
      channel: 'TRAD',
      terms: [
        { term: 12, tna: 0, dealerContributionPct: 5, installmentPer1000: 83.33 },
        { term: 24, tna: 0, dealerContributionPct: 10, installmentPer1000: 41.67 },
        { term: 36, tna: 7.9, dealerContributionPct: 10, installmentPer1000: 32.67 },
        { term: 48, tna: 11.9, dealerContributionPct: 10, installmentPer1000: 28.37 },
        { term: 60, tna: 13.9, dealerContributionPct: 10, installmentPer1000: 25.65 },
      ],
    },
    {
      id: 'citroen-gama-36',
      name: 'Tasa fija Citroën',
      detail: 'Toda la gama',
      maxAmount: 36000000,
      models: 'all',
      rateType: 'fija',
      audience: 'general',
      channel: 'TRAD',
      terms: [
        { term: 12, tna: 13.9, dealerContributionPct: 8, installmentPer1000: 92.17 },
        { term: 18, tna: 23.9, dealerContributionPct: 8, installmentPer1000: 70.84 },
        { term: 24, tna: 27.9, dealerContributionPct: 8, installmentPer1000: 59.72 },
        { term: 36, tna: 33.9, dealerContributionPct: 8, installmentPer1000: 50.55 },
        { term: 48, tna: 35.9, dealerContributionPct: 8, installmentPer1000: 45.8 },
        { term: 60, tna: 36.9, dealerContributionPct: 8, installmentPer1000: 43.17 },
      ],
    },
    {
      id: 'citroen-jumper-45',
      name: 'Tasa fija Jumper',
      detail: 'Exclusiva Citroën Jumper',
      maxAmount: 45000000,
      models: ['Jumper'],
      rateType: 'fija',
      audience: 'general',
      channel: 'TRAD',
      terms: [
        { term: 12, tna: 13.9, dealerContributionPct: 8, installmentPer1000: 92.17 },
        { term: 18, tna: 23.9, dealerContributionPct: 8, installmentPer1000: 70.84 },
        { term: 24, tna: 27.9, dealerContributionPct: 8, installmentPer1000: 59.72 },
        { term: 36, tna: 33.9, dealerContributionPct: 8, installmentPer1000: 50.55 },
        { term: 48, tna: 35.9, dealerContributionPct: 8, installmentPer1000: 45.8 },
        { term: 60, tna: 36.9, dealerContributionPct: 8, installmentPer1000: 43.17 },
      ],
    },
  ],
};
